import { useContext } from 'react';
import './PageCB.css';
import CheckBox from '../../generics/CheckBox';
// import { StepContext } from '../../contexts/StepContext';
import { SlidesContext } from '../../contexts/SlidesContext';
import ReviewFormattedMessage from '../../generics/ReviewFormattedMessage';

export default function PageCB({ slide }) {
    // const { step } = useContext(StepContext);
    const { slidesAnswers } = useContext(SlidesContext);

    // Fallback for missing answers array
    const answerGroup = slidesAnswers && slidesAnswers[slide.inputNumber] ? slidesAnswers[slide.inputNumber] : {};
    return (
        <div className="PageCB animate__animated animate__fadeInRight">
            <div className="PageCB-help">
                <ReviewFormattedMessage descriptor={slide.aide} />
            </div>
            <div className="PageCB-title">
                <div className="PageCB-title-header">
                    <ReviewFormattedMessage descriptor={slide.pageTitleType} />
                </div>
                <div className="PageCB-titleInfo">
                    {Array.isArray(slide.pageTitleInfos) && slide.pageTitleInfos.map((i, key) => (
                        <p key={key}><ReviewFormattedMessage descriptor={i.info} /></p>
                    ))}
                </div>
            </div>
            <div className="PageCB-list">
                {Array.isArray(slide.inputsCB) && slide.inputsCB.map((checkbox, key) => (
                    <CheckBox
                        key={key}
                        label={checkbox.labelCB}
                        value={answerGroup[checkbox.key]}
                        index={slide.inputNumber}
                        inputKey={checkbox.key}
                    />
                ))}
            </div>
        </div>
    );
}
